import _ from 'lodash';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';

@inject('artistStore')
@observer
class ArtistTierFilter extends React.Component {
	render () {
		const { statusFilter = {} } = this.props.artistStore;
		const status = _(statusFilter).values().first();

		return (
			<div>
				<div className="grid-x">
					<div className="cell auto">
						<nav>
							<ul className="menu horizontal artist-nav">
								{/* <li>
									<NavLink
										isActive={ this.isActive('ALL') }
										to={ `/manage-artists/${status}/ALL` }
									>
										All
									</NavLink>
								</li> */}
								{ (status != 'PENDING') ? 
									<>										
										<li>
											<NavLink
												// data-ta="tier1ArtistsButton"
												isActive={ this.isActive('ALL') }
												to={ `/manage-artists/${status}/ALL` }
											>
												All
											</NavLink>
										</li>
										<li>
											<NavLink
												// data-ta="tier1ArtistsButton"
												isActive={ this.isActive('TIER_1') }
												to={ `/manage-artists/${status}/TIER_1` }
											>
												Tier 1
											</NavLink>
										</li>
										<li>
											<NavLink
												isActive={ this.isActive('TIER_2') }
												to={ `/manage-artists/${status}/TIER_2` }
											>
												Tier 2
											</NavLink>
										</li>
										<li>
											<NavLink
												isActive={ this.isActive('TIER_3') }
												to={ `/manage-artists/${status}/TIER_3` }
											>
												Tier 3
											</NavLink>
										</li>
										<li>
											<NavLink
												isActive={ this.isActive('TIER_4') }
												to={ `/manage-artists/${status}/TIER_4` }
											>
												Tier 4
											</NavLink>
										</li>
										<li>
											<NavLink
												isActive={ this.isActive('TIER_5') }
												to={ `/manage-artists/${status}/TIER_5` }
											>
												Tier 5
											</NavLink>
										</li>
										<li>
											<NavLink
												isActive={ this.isActive('NOT_APPROVED') }
												to={ `/manage-artists/${status}/NOT_APPROVED` }
											>
												Not Approved
											</NavLink>
										</li> 
									</> : null
								}
								{ (status == 'PENDING' || status == 'CANCELLED') ? 
								<>
									<li>
										<NavLink
											isActive={ this.isActive('IN_REVIEW') }
											to={ `/manage-artists/${status}/IN_REVIEW` }
										>
											In Review
										</NavLink>
									</li>
								</> : null
								}
							</ul>
						</nav>
					</div>
				</div>
			</div>
		);
	}

	isActive (filterSlug) {
		return () => {
			const { tierFilter = {} } = this.props.artistStore;
			const tierValue = _(tierFilter).values().first() || '';
			// console.log("tierValue");
			// console.log(tierValue);
			const isTierFilterSelected = tierValue.toUpperCase().replace(/\s/g, '_') === filterSlug;

			return isTierFilterSelected;
		}
	}
}

export default ArtistTierFilter;
